import styled from 'styled-components';

export const SortableHeader = styled.div<{ $align?: 'left' | 'center' | 'right'; $variant?: 'default' | 'punchup' }>`
	padding: ${({ $variant }) => ($variant === 'punchup' ? '0' : '16px 8px')};
	text-align: ${({ $align }) => $align || 'left'};
	font-weight: ${({ $variant }) => ($variant === 'punchup' ? '500' : '600')};
	font-size: ${({ $variant }) => ($variant === 'punchup' ? '14px' : '18px')};
	color: ${({ theme, $variant }) => ($variant === 'punchup' ? theme.colors.black : theme.colors.white)};
	cursor: pointer;
	user-select: none;
	white-space: nowrap;

	&:hover {
		opacity: 0.8;
	}

	&:active {
		opacity: 0.7;
	}
`;

export const SortableContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: inherit;
	gap: 6px;
`;

export const SortIcon = styled.span<{ $isActive?: boolean; $variant?: 'default' | 'punchup' }>`
	display: inline-flex;
	align-items: center;
	color: ${({ theme, $variant }) => ($variant === 'punchup' ? theme.colors.black : theme.colors.white)};
	opacity: ${({ $isActive }) => ($isActive ? 1 : 0.4)};
	transition: opacity 0.2s ease;

	svg {
		width: ${({ $variant }) => ($variant === 'punchup' ? '14px' : '16px')};
		height: ${({ $variant }) => ($variant === 'punchup' ? '14px' : '16px')};
	}
`;
